import Storage from './Storage';

/**
 * Store ClientSettings
 * 
 */
class ClientSettings extends Storage {
    storeName = 'client_settings_';
    hasOldKey = true;

    /**
     * ClientSettings constructor
     * 
     * @param {string} id client id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }
}

export default ClientSettings;